
const env = {
    env: process.env.REACT_APP_ENV,
    app: {
        port: 3000
    },
    urls: {
      graphql: process.env.REACT_APP_GRAPHQL_URL,
      reports: process.env.REACT_APP_REPORT_URL,
      employees: process.env.REACT_APP_EMPLOYEES_URL
    }
};

module.exports = env;
